
export const styles = theme => ({
  datePicker: {
    width: '100%',
    maxWidth: 300
  }
   
});
